<template>
  <main class="contaniner-pay">
    <!-- 顶通 -->
    <div class="paygame-container">
      <!--tab切换-->
      <tabs></tabs>
      <!-- 游戏列表 -->
      <div class="paygame-list-container" v-show="showList">
        <!-- 左边 -->
        <div class="module-left">
          <div class="module-title">
            <div class="module-title-icon"></div>
            <div class="module-title-text">{{ $t("paygame.choseGame") }}</div>
          </div>
          <div class="game-list" v-if="gameList.length">
            <div
              v-for="(item, index) in gameList"
              @click="showDetail(item)"
              class="item"
              :style="{ 'background-image': 'url(' + item.game_image + ')' }"
              :key="index"
              ga-data="2601001"
            >
              <div class="cover" v-if="item.hover_image && item.game_name">
                <div
                  class="icon"
                  :style="{
                    'background-image': 'url(' + item.hover_image + ')',
                  }"
                ></div>
                <p class="title one-line">
                  {{ $t("paygame.entryPay") }}{{ $t("paygame.leftQuo")
                  }}{{ item.game_name }}{{ $t("paygame.rightQuo") }}
                </p>
              </div>
            </div>
          </div>
          <div class="emptyData" v-if="!bigLoading && !gameList.length">
            {{ $t("common.emptyData") }}
          </div>
        </div>
        <!-- 右边 -->
        <div class="module-right">
          <a class="service-box" href="/service/" ga-data="2602001">
            <div class="question-icon common-problem-icon"></div>
            <span class="desc">{{ $t("paygame.commonQue") }}</span>
          </a>
        </div>
      </div>
      <!-- 遊戲儲值 -->
      <div class="paygame-detail-container" v-show="!showList">
        <!-- 儲值主体 -->
        <div class="box-left">
          <div class="nav">
            <span class="breadcrumb-icon"></span>
            <el-breadcrumb separator=">">
              <el-breadcrumb-item ga-data="2701007">{{
                $t("paygame.pay")
              }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{
                $t("paygame.paygame")
              }}</el-breadcrumb-item>
              <el-breadcrumb-item
                ><span class="game-name">{{
                  params.game_name
                }}</span></el-breadcrumb-item
              >
            </el-breadcrumb>
          </div>
          <el-form
            ref="ruleForm"
            label-width="200px"
            label-position="left"
            style="margin-top: 40px"
          >
            <!--游戏名称-->
            <el-form-item :label="$t('paygame.paygameName')">
              <div>{{ params.game_name }}</div>
            </el-form-item>
            <!--会员账号-->
            <el-form-item :label="$t('paygame.account')">
              <div>{{ params.account }}</div>
            </el-form-item>
            <!--选择区服-->
            <el-form-item :label="$t('paygame.gameServer')">
              <el-select
                placeholder=""
                @change="selectServer"
                style="width: 600px"
                v-model="params.id_server"
              >
                <template v-for="(item, index) in serverList">
                  <el-option
                    :key="index"
                    :label="item.value"
                    :value="item.id_server"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <!--选择角色-->
            <el-form-item :label="$t('paygame.gameRole')">
              <el-select
                placeholder=""
                @change="selectRole"
                style="width: 600px"
                v-model="params.id_role"
              >
                <template v-for="(item, index) in roleList">
                  <el-option
                    :key="index"
                    :label="item.cpRoleName"
                    :value="item.id_role"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
            <!--选择币种-->
            <el-form-item :label="$t('paygame.payCurrency')">
              <el-radio-group
                v-model="params.currency"
                @change="changeCurrency"
              >
                <template v-for="(item, index) in currencyList">
                  <el-radio :key="index" :label="item.currency">
                    <div class="currency">
                      <!-- <img class="currency-country" :src="item.icon" alt="" /> -->
                      <span class="currency-text">{{ item.currency }}</span>
                    </div>
                  </el-radio>
                </template>
              </el-radio-group>
            </el-form-item>
            <!--支付方式-->
            <el-form-item :label="$t('paygame.payWay')">
              <div class="item-box">
                <div class="pay-chanel-box">
                  <div
                    v-show="payChannel.length > 0"
                    @click="selectPayChannel(item, 1)"
                    class="green-border pay-channel-style"
                    v-for="(item, index) in payChannel"
                    :key="index"
                    :class="[
                      {
                        selected:
                          params.pay_mode === item.pay_mode &&
                          params.payment_type == item.payment_type,
                      },
                    ]"
                    ga-data="2701004"
                  >
                    <div class="recommended" v-if="item.recommended === 1">
                      {{ $t("paygame.recommended") }}
                    </div>
                    <img
                      class="pay-icon"
                      v-if="item.payment_icon"
                      :src="item.payment_icon"
                    />
                    <div class="pay-type">{{ item.payment_desc }}</div>
                  </div>
                </div>
              </div>
            </el-form-item>
            <!--储值数量-->
            <el-form-item :label="$t('paygame.payCount')">
              <template v-if="productList.length">
                <div class="product" v-if="isProductSelect">
                  <vue-scroll
                    :ops="productList.length > 4 ? options : {}"
                    :style="styleProduct"
                  >
                    <div
                      class="item-box product-list"
                      v-for="(item, index) in productList"
                      :key="index"
                    >
                      <div class="recommended" v-if="item.recommended === 1">
                        {{ $t("paygame.recommended") }}
                      </div>
                      <div
                        @click="selectProduct(item)"
                        class="item-cont green-border product-box"
                        :class="{
                          selected: params.product_id == item.product_id,
                        }"
                        ga-data="2701003"
                      >
                        <div
                          v-show="item.product_icon"
                          class="product-icon"
                          :style="{
                            'background-image':
                              'url(' + item.product_icon + ')',
                          }"
                        ></div>
                        <span
                          class="product-name"
                          :class="{ 'with-sale': item.sale_product_name }"
                        >
                          <span class="green-text">{{
                            item.product_price
                          }}</span
                          ><span class="grey-text"
                            >&nbsp;({{ item.currency }})</span
                          ></span
                        >
                        <span
                          v-if="item.sale_product_name"
                          class="product-name sale-product-name"
                          >{{ item.sale_product_name }}</span
                        >
                        <div
                          class="remark-box"
                          v-if="
                            item.marketing_desc1 ||
                              item.marketing_desc2 ||
                              item.first_recharge_desc1 ||
                              item.first_recharge_desc2
                          "
                        >
                          <div class="text">
                            <p class="one-line">
                              {{
                                item.first_recharge_desc1 ||
                                  item.marketing_desc1
                              }}
                            </p>
                            <p class="one-line">
                              {{
                                item.first_recharge_desc2 ||
                                  item.marketing_desc2
                              }}
                            </p>
                          </div>
                        </div>
                        <div class="green-module">
                          <div class="check"></div>
                        </div>
                      </div>
                    </div>
                  </vue-scroll>
                </div>
                <div class="product" v-else>
                  <vue-scroll
                    :ops="productList.length > 4 ? options : {}"
                    :style="styleProduct"
                  >
                    <div
                      class="product-item"
                      v-for="(item, index) in productList"
                      :key="index"
                    >
                      <div class="recommended" v-if="item.recommended === 1">
                        {{ $t("paygame.recommended") }}
                      </div>
                      <div class="item product-item-price">
                        <span class="product-item-price-num">{{
                          item.product_price
                        }}</span>
                        <span>({{ item.currency }})</span>
                      </div>
                      <div class="product-item-desc">
                        <span class="product-item-desc1">{{
                          item.marketing_desc1
                        }}</span>
                        <span class="product-item-desc2">{{
                          item.marketing_desc2
                        }}</span>
                      </div>
                    </div>
                  </vue-scroll>
                </div>
              </template>
            </el-form-item>
            <el-form-item
              v-if="isProductSelect"
              :label="$t('paygame.payAmount')"
            >
              <div class="item-box" style="margin-bottom: 0">
                <div class="item-cont money" v-if="params.product_price">
                  <span class="green-text">{{ params.product_price }}</span
                  ><span class="grey-text">&nbsp;({{ params.currency }})</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('paygame.captcha')">
              <div class="item-box" style="margin-bottom: 0">
                <div class="item-cont code-box">
                  <input
                    class="code-input"
                    v-bind:value="params.captcha_code"
                    v-on:input="getInput($event.target.value)"
                    maxlength="4"
                    :placeholder="$t('paygame.insertCaptcha')"
                  />
                  <div
                    class="code-img"
                    @click="getImage()"
                    :style="{
                      'background-image': 'url(' + params.imgUrl + ')',
                    }"
                    ga-data="2701005"
                  >
                    <div class="captcha-loading" v-show="!params.imgUrl"></div>
                    <div class="cover-text">
                      <span>{{ $t("paygame.change") }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="errMsg">
                <span class="err-text" v-if="errMsg2Key">{{
                  errMsg2[errMsg2Key]
                }}</span>
              </div>
            </el-form-item>
            <div
              ref="btnSure"
              class="btn btn-sure"
              @click="makeSure"
              ga-data="2701006"
            >
              <span>{{ $t("paygame.payNow") }}</span>
            </div>
          </el-form>
        </div>
        <div class="box-right">
          <div class="policy-box">
            <div
              class="game-icon"
              :style="{ 'background-image': 'url(' + params.icon + ')' }"
            ></div>
            <p class="game-name">{{ params.game_name }}</p>
            <div class="game-policy">
              <el-checkbox v-model="agree" ga-data="2703001"></el-checkbox>
              <p class="policy-text">
                {{ $t("paygame.agree1") }}<br /><a href="/terms/">{{
                  $t("paygame.agree2")
                }}</a>
              </p>
            </div>
          </div>

          <div class="related-links">
            <a class="service-box" href="/service/" ga-data="2602001">
              <div class="question-icon common-problem-icon"></div>
              <span class="desc">{{ $t("paygame.commonQue") }}</span>
            </a>

            <a class="service-box" href="/paygame_history/" ga-data="2702001">
              <div class="question-icon history-icon"></div>
              <span class="desc">{{ $t("paygame.payHistory") }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!--订单确认和支付成功-->
    <modal-order-confirm
      v-if="popShowMakeSure"
      :data="orderDetailInfo"
      :type="type"
      :isValidCaptcha="popCaptcha"
      :message="errMsgSure"
      @closeOrderConfirm="closeOrderConfirm"
      @createOrder="createOrder"
      @getInput="getInput"
      @getImage="getImage"
    ></modal-order-confirm>

    <!--订单支付中-->
    <modal-order-payLoading
      :data="params"
      v-if="popShowPayLoading"
      @getOrderDetail="getOrderDetail"
      @goRePay="goRePay"
      @closeModal="closeModal"
    ></modal-order-payLoading>

    <!--订单支付结果-->
    <modal-order-PayResult
      v-if="popShowPaySearch"
      :btnMsg="btnMsg"
      :checkBtn="checkBtn"
      @checkOrder="checkOrder"
      @goRePay="goRePay"
      @rePay="rePay"
    ></modal-order-PayResult>

    <!--弹窗提示-->
    <modal-message
      v-if="errMsgInfo"
      :message="errMsgInfo"
      @closeModal="closeModal"
    ></modal-message>

    <!-- loading -->
    <loading class="bui-loading" v-show="bigLoading"></loading>
  </main>
</template>

<script>
import Vue from "vue";
import vuescroll from "vuescroll";
import { mapGetters } from "vuex";
import tabs from "./component/tabs/index.vue";
import modalMessage from "./component/modal/modal-message/index.vue";
import loading from "@/component/loading/index.vue";
import modalOrderConfirm from "./component/modal/modal-orderConfirm/index.vue";
import modalOrderPayLoading from "./component/modal/modal-orderPayLoading/index.vue";
import modalOrderPayResult from "./component/modal/modal-orderPayResult/index.vue";
require("../elementUI/elementUI");
Vue.use(vuescroll);

export default {
  name: "index",
  data() {
    return {
      // 1: 确认订单 2: 支付成功
      type: 1,
      distribution_region: 5,
      popCaptcha: false,
      loginStatus: false,
      bigLoading: true,
      // 弹窗提示信息
      errMsgInfo: "",
      // 确认弹窗点击下单，返回报错信息
      errMsgSure: "",
      errMsg2: {
        msg1: this.$t("paygame.msg1"),
        msg2: this.$t("paygame.msg2"),
        msg3: this.$t("paygame.msg3"),
        msg4: this.$t("paygame.msg4"),
        msg5: this.$t("paygame.msg5"),
        msg6: this.$t("paygame.msg6"),
        msg7: this.$t("paygame.msg7"),
        msg8: this.$t("paygame.msg8"),
        msg9: this.$t("paygame.err1"),
      },
      // errmsg标志位
      errMsg2Key: "",
      // 控制确认订单和支付成功弹窗
      popShowMakeSure: false,
      // 控制支付中弹窗
      popShowPayLoading: false,
      // 控制支付结果
      popShowPaySearch: false,
      // 游戏列表选择
      showList: true,
      // 接口2 儲值游戏选择模块信息列表
      gameList: [],
      // 接口3 获取游戏中用户的角色信息接口（大区服、小区服、角色信息）
      serverRoleList: [],
      // 支持的币种列表
      currencyList: [],
      // 接口4 产品列表
      productList: [],
      // 商品是否可选
      isProductSelect: true,
      // 接口5 支付方式
      payChannel: [],
      // 区服列表
      serverList: [],
      // 角色名称
      roleList: [],
      // 儲值请求提交参数（需要清空）
      params: {
        game_base_id: "", // 游戏基础ID
        game_id: "", // 游戏ID
        game_name: "", // 游戏名称
        account: "", // 账号
        icon: "", // 支付选择页 右边游戏大icon
        id_server: "",
        cp_server_id: "", // 用户所在的游戏服务器区服id
        serverStatus: "", // 小区服状态
        id_role: "",
        cp_role_id: "", // 用户游戏内角色id
        cp_role_name: "", // 角色名字
        cp_role_pay_status: "", // 角色是否可以充值
        product_id: "", // product的ID
        product_name: "", // product名称
        product_icon: "", // 商品图片icon
        payment_desc: "", // 支付方式名称
        marketing_desc_1: "",
        marketing_desc_2: "",
        product_price: "", // 实付金额
        currency: "", // currency
        pay_mode: "", // 支付方式
        payment_type: null, // 具体支付方式
        imgUrl: "",
        captcha_token: "", // 验证码token
        captcha_code: "", //captcha_code
      },
      // 订单号
      order_no: "",
      // 充值跳转链接
      payment_url: "",
      // 儲值协议
      agree: true,
      defaultItem: {
        game_image: require("./imgs/defaultImg.png"),
      },
      // 充值页面开关
      main_switch_status: "", // 支付总开关状态。0 关闭，1 开启
      secondary_switch_status: "", // 游戏充值二级菜单开关状态。main_switch_status = 1 时返回；0 关闭，1 开启
      // 查询按钮倒计时
      btnMsg: this.$t("paygame.payTip8"),
      btnTime: 10,
      timeInterval: null,
      checkBtn: true,
      // 订单详情
      orderDetailInfo: {
        game_id: "",
        game_name: "",
        account: "",
        cp_role_id: "",
        cp_role_name: "",
        pay_mode: "",
        payment_desc: "",
        product_name: "",
        product_icon: "",
        marketing_desc1: "",
        marketing_desc2: "",
        product_price: "",
        currency: "",
        captcha_code: "",
        imgUrl: "",
      },
      // 滚动条配置
      options: {
        scrollPanel: {
          scrollingX: false,
          initialScrollY: false,
          easing: "easeInQuad",
        },
        vuescroll: {
          wheelScrollDuration: 200,
        },
        rail: {
          background: "#f2f2f2",
          opacity: 1,
          size: "8px",
          specifyBorderRadius: "8px",
          keepShow: true,
          gutterOfEnds: 0,
          gutterOfSide: 0,
        },
        bar: {
          keepShow: true,
          background: "#60c8f1",
          opacity: 1,
          size: "8px",
          specifyBorderRadius: "8px",
        },
      },
    };
  },
  components: {
    tabs,
    modalMessage,
    loading,
    modalOrderConfirm,
    modalOrderPayLoading,
    modalOrderPayResult,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    styleProduct() {
      return {
        height: this.productList.length > 4 ? "305px" : "auto",
      };
    },
  },
  methods: {
    // 1.获取平台充值开关状态
    getSwitchStatus() {
      this.$apis.paygame
        .getSwitchStatus(this.distribution_region)
        .then(({ data }) => {
          if (data.code == 0) {
            this.main_switch_status = data.data.main_switch_status;
            this.secondary_switch_status = data.data.secondary_switch_status;

            // 支付总开关和游戏充值二级菜单开关状态是否开启
            if (
              this.main_switch_status === 1 &&
              this.secondary_switch_status === 1
            ) {
              // 2.获取支持网页支付游戏信息接口
              this.getGameList();
              // 判断是否登录
              if (this.userInfo.mid) {
                this.loginStatus = true;
                this.params.account = this.userInfo.nick_name || "N/A";
              } else {
                this.loginStatus = false;
              }
            } else {
              this.$router.push({ name: "home" });
            }
          } else {
            this.$router.push({ name: "home" });
          }
        });
    },
    // 获取支持网页支付游戏信息接口
    getGameList() {
      this.$apis.paygame
        .getGameList(this.distribution_region)
        .then(({ data }) => {
          if (data.code == 0 && data.data.length) {
            this.gameList = data.data;
            let defaultItemLength = this.gameList.length % 3;
            if (defaultItemLength != 0) {
              for (var i = 0; i < 3 - defaultItemLength; i++) {
                this.gameList.push(this.defaultItem);
              }
            }
          }
          this.bigLoading = false;
        });
    },
    clearOrderData() {
      this.orderDetailInfo &&
        Object.keys(this.orderDetailInfo).forEach((key) => {
          this.orderDetailInfo[key] = "";
        });
    },
    // 获取图形验证码
    getImage() {
      this.params.imgUrl = "";
      this.$apis.paygame
        .getCaptcha(this.distribution_region)
        .then(({ data }) => {
          if (data.code == 0) {
            this.params.imgUrl = this.orderDetailInfo.imgUrl =
              data.data.img_url;
            this.params.captcha_token = this.orderDetailInfo.captcha_token =
              data.data.img_token;
          }
        });
    },
    // 根据gameBaseId查询接口3 区服、角色信息 serverRoleList
    getRoleList() {
      this.$apis.paygame
        .getRoleList(this.distribution_region, this.params.game_base_id)
        .then(({ data }) => {
          if (data.code == 0) {
            // 获取区服、角色数据
            this.serverRoleList = data.data;
            // 对接口3数据做判断，如果用户没有任何角色信息，则不打开充值页面
            if (this.serverRoleList.length > 0) {
              // 是否有角色
              let isCreateRole = false;
              this.serverRoleList.map((item) => {
                if (item.cp_servers.length > 0) {
                  this.showList = false;
                  isCreateRole = true;
                  // 处理接口3数据
                  this.handleServerList();
                }
              });
              if (!isCreateRole) {
                this.errMsgInfo = this.$t("paygame.msg9");
              }
            } else {
              this.errMsgInfo = this.$t("paygame.err2");
            }
          } else if (data.code == -101) {
            this.$router.push({
              name: "login",
              query: { redirect: location.href },
            });
          } else if (data.code == 2012) {
            this.errMsgInfo = this.$t("paygame.msg10");
          } else {
            this.errMsgInfo = this.$t("paygame.err2");
          }
          this.bigLoading = false;
        })
        .catch(() => {
          this.errMsgSure = this.$t("paygame.err2");
          this.bigLoading = false;
        });
    },
    // 获取支付方式
    async getChannelList() {
      const res = await this.$apis.paygame.getChannelList(
        this.distribution_region,
        this.params.game_base_id,
        this.params.currency
      );
      if (res.data.code == 0 && res.data.data.length) {
        this.payChannel = res.data.data;
        // 获取商品列表
        this.getProductList(this.params.game_id, this.params.currency, this.payChannel[0].pay_mode);
        // 选择默认支付方式
        this.selectPayChannel(this.payChannel[0], 0);
      } else if (res.data.code == 2000) {
        window.location.href = "../paygame_history/";
      }
    },
    // 获取支持的币种列表
    getCurrencyList(gameId) {
      this.$apis.paygame
        .getCurrencyList(this.distribution_region, gameId)
        .then(({ data }) => {
          if (data.code === 0 && data.data && data.data.length) {
            this.currencyList = data.data;
            // 币种赋初始值
            this.params.currency = this.currencyList[0].currency;
            // 支付方式
            this.getChannelList();
          } else {
            this.currencyList = [];
          }
        });
    },
    // 根据game_id查询商品信息
    getProductList(gameId, currency, pay_mode) {
      this.emptyProductSelectInfo();
      // 根据gameid查询接口4 商品信息，gameid依赖区服接口，需要用户先选择 大区服/小区服，确定gameid
      this.$apis.paygame
        .getProductList(this.distribution_region, gameId, currency, pay_mode)
        .then(({ data }) => {
          if (data.code == 0 && data.data && data.data.length) {
            this.productList = data.data;
          } else {
            this.productList = [];
          }
        });
    },
    // 进入儲值详情
    showDetail(item) {
      // 显示loading
      this.bigLoading = true;
      if (!this.loginStatus) {
        this.$router.push({
          name: "login",
          query: { redirect: location.href },
        });
      } else {
        if (item.game_base_id && item.game_name) {
          this.params.game_base_id = item.game_base_id;
          this.params.game_name = item.game_name;
          this.params.icon = item.pay_page_image;
          // 调用图形验证码
          this.getImage();

          // 根据gameBaseId查询接口3 区服、角色信息 serverRoleList
          this.getRoleList();
        } else {
          this.bigLoading = false;
          return;
        }
      }
    },
    // 区服列表
    handleServerList() {
      this.serverRoleList.forEach((item) => {
        let temp_serverList = [];
        // 获取区服列表
        if (item.cp_servers.length > 0) {
          temp_serverList = item.cp_servers.map((serverItem) => {
            return {
              id_server: `${item.game_id}-${serverItem.cp_server_id}`,
              game_id: item.game_id,
              server_id: serverItem.cp_server_id,
              value: serverItem.cp_server_name,
              status: serverItem.cp_server_status,
            };
          });
        }

        this.serverList = [...this.serverList, ...temp_serverList];
        // 区服赋初始值
        this.params.game_id = this.serverList[0].game_id;
        this.params.id_server = this.serverList[0].id_server;
        this.params.cp_server_id = this.serverList[0].server_id;
        this.params.serverStatus = this.serverList[0].status;
        this.handleRoleList(
          this.serverList[0].game_id,
          this.serverList[0].server_id
        );
        // 获取支持的币种列表
        this.getCurrencyList(this.serverList[0].game_id);
      });
    },
    // 角色列表
    handleRoleList(gameId, serverId) {
      this.serverRoleList.forEach((item) => {
        if (item.game_id === gameId && item.cp_servers.length) {
          item.cp_servers.forEach((serverItem) => {
            if (
              serverItem.cp_server_id === serverId &&
              serverItem.cp_roles.length
            ) {
              this.roleList = serverItem.cp_roles.map((roleItem) => {
                return {
                  id_role: `${item.game_id}-${serverItem.cp_server_id}-${
                    roleItem.cpRoleId
                  }`,
                  game_id: item.game_id,
                  server_id: serverItem.cp_server_id,
                  cpRoleId: roleItem.cpRoleId,
                  cpRoleName: roleItem.cpRoleName,
                  cpRolePayStatus: roleItem.cpRolePayStatus,
                };
              });
              // 角色赋初始值
              this.params.id_role =
                this.roleList.length > 0 ? this.roleList[0].id_role : "";
              this.params.cp_role_id =
                this.roleList.length > 0 ? this.roleList[0].cpRoleId : "";
              this.params.cp_role_name =
                this.roleList.length > 0 ? this.roleList[0].cpRoleName : "";
              this.params.cp_role_pay_status =
                this.roleList.length > 0
                  ? this.roleList[0].cpRolePayStatus
                  : "";
            }
          });
        }
      });
    },
    // 同时选择 大区服和小区服 id
    selectServer(id) {
      // 根据区服id获取包含多属性的对象
      const serverSelected = this.serverList.filter(
        (item) => item.id_server === id
      );

      // 更新gameId的时候，要更新商品列表（请求商品接口
      if (this.params.game_id !== serverSelected[0].game_id) {
        this.params.game_id = serverSelected[0].game_id;
        this.getCurrencyList(this.params.game_id);
      }
      this.params.cp_server_id = serverSelected[0].server_id;
      this.params.serverStatus = serverSelected[0].status;
      // 根据游戏和区服获取角色
      if (this.params.game_id && this.params.cp_server_id) {
        this.handleRoleList(this.params.game_id, this.params.cp_server_id);
      } else {
        this.roleList = [];
      }

      this.emptyErrMsg2Key();
    },
    // 选择角色信息
    selectRole(id) {
      // 根据角色id获取包含多属性的对象
      const roleSelected = this.roleList.filter((item) => item.id_role === id);
      this.params.cp_role_id = roleSelected[0].cpRoleId;
      this.params.cp_role_name = roleSelected[0].cpRoleName;
      this.params.cp_role_pay_status = roleSelected[0].cpRolePayStatus;

      this.emptyErrMsg2Key();
    },
    // 选择币种
    changeCurrency(currency) {
      this.params.currency = currency;
      this.getChannelList()
      // this.getProductList(this.params.game_id, currency, this.params.pay_mode);
    },
    // 选择商品
    selectProduct(product) {
      this.params.product_id = product.product_id;
      this.params.product_name = product.product_name;
      this.params.marketing_desc1 = product.marketing_desc1;
      this.params.marketing_desc2 = product.marketing_desc2;
      this.params.product_price = product.product_price;
      this.params.product_icon = product.product_icon;

      this.emptyErrMsg2Key();
    },
    // 选择支付方式
    selectPayChannel(item, type) {
      // 获取商品列表
      if (
        type &&
        (this.params.pay_mode !== item.pay_mode ||
          this.params.payment_type !== item.payment_type)
      ) {
        this.getProductList(
          this.params.game_id,
          this.params.currency,
          item.pay_mode
        );
      }

      this.params.payment_type = item.payment_type;
      this.params.pay_mode = item.pay_mode;
      this.params.payment_desc = item.payment_desc;
      this.payment_url = item.payment_url;

      if (
        (this.params.pay_mode === 107 && this.params.payment_type === "pin") ||
        (this.params.pay_mode === 108 && this.params.payment_type === "card") ||
        (this.params.pay_mode === 108 && this.params.payment_type === "vietnamVMS") ||
        (this.params.pay_mode === 108 && this.params.payment_type === "vietnamVTT") ||
        (this.params.pay_mode === 108 && this.params.payment_type === "vietnamFPT") ||
        (this.params.pay_mode === 108 && this.params.payment_type === "vietnamZING") ||
        (this.params.pay_mode === 108 && this.params.payment_type === "vietnamVNP")
      ) {
        this.isProductSelect = false;
      } else {
        this.isProductSelect = true;
      }

      this.emptyErrMsg2Key();
    },
    // 点击确认按钮，弹出充值信息确认弹窗
    makeSure() {
      if (!this.params.game_id && !this.params.cp_server_id) {
        this.errMsg2Key = "msg1";
        return;
      } else if (this.params.serverStatus == 1) {
        this.errMsg2Key = "msg7";
        return;
      } else if (!this.params.cp_role_id) {
        this.errMsg2Key = "msg2";
        return;
      } else if (this.params.cp_role_pay_status == 1) {
        this.errMsg2Key = "msg8";
        return;
      } else if (this.isProductSelect && !this.params.product_id) {
        this.errMsg2Key = "msg3";
        return;
      } else if (this.isProductSelect && !this.params.pay_mode) {
        this.errMsg2Key = "msg4";
        return;
      } else if (!this.params.captcha_code) {
        this.errMsg2Key = "msg5";
        return;
      } else if (!this.agree) {
        this.errMsg2Key = "msg6";
        return;
      }

      if (this.isProductSelect) {
        Object.keys(this.orderDetailInfo).forEach((key) => {
          this.orderDetailInfo[key] = this.params[key];
        });
        this.type = 1;
        this.popShowMakeSure = true;
      } else {
        this.createOrder("common");
      }
    },
    // 游戏充值下单 确认弹窗按钮点击
    createOrder(tag) {
      this.bigLoading = true;
      this.$apis.paygame
        .addPayOrder(
          this.distribution_region,
          this.params.game_base_id,
          this.params.game_id,
          this.params.cp_server_id,
          this.params.cp_role_id,
          this.params.product_id,
          this.params.product_name,
          this.params.marketing_desc_1,
          this.params.marketing_desc_2,
          this.params.product_price,
          this.params.currency,
          this.params.pay_mode,
          this.params.payment_type,
          this.params.captcha_token,
          this.params.captcha_code
        )
        .then(({ data }) => {
          if (data.code == 0) {
            this.payment_url = data.data.redirect_url;
            this.order_no = data.data.order_no;
            this.popShowMakeSure = false;
            this.popShowPayLoading = true;
            this.popCaptcha = false;
            // 打开去支付
            if (this.payment_url) {
              window.open(this.payment_url);
            }
          } else {
            if (data.code === -101) {
              this.$router.push({
                name: "login",
                query: { redirect: location.href },
              });
            } else if (data.code == -105) {
              if (this.isProductSelect) {
                this.errMsgSure = this.$t("paygame.err1");
                this.popCaptcha = true;
              } else {
                this.errMsg2Key = "msg9";
              }
            } else if (data.code == 1001) {
              this.errMsgSure = this.$t("paygame.err2");
            } else if (data.code == 2000) {
              this.errMsgSure = this.$t("paygame.err3");
            } else if (data.code == 2001) {
              this.errMsgSure = this.$t("paygame.err4");
            } else if (data.code == 2002) {
              this.errMsgSure = this.$t("paygame.err5");
            } else if (data.code == 2003) {
              this.errMsgSure = this.$t("paygame.err6");
            } else if (data.code == 2004) {
              this.errMsgSure = this.$t("paygame.err7");
            } else if (data.code == 2005) {
              this.errMsgSure = this.$t("paygame.err8");
            } else if (data.code == 2006) {
              this.errMsgSure = this.$t("paygame.err9");
            } else if (data.code == 2007) {
              this.errMsgSure = this.$t("paygame.err10");
            } else if (data.code == 2008) {
              this.errMsgSure = this.$t("paygame.err11");
            } else if (data.code == 2009) {
              this.errMsgSure = this.$t("paygame.err12");
            } else if (data.code == 2011) {
              this.errMsgSure = this.$t("paygame.err13");
            } else if (data.code == 2012) {
              this.errMsgSure = this.$t("paygame.msg10");
            } else {
              // 服务器内部错误
              this.errMsgSure = this.$t("paygame.err2");
            }
            if (tag === "common") {
              this.errMsgInfo = this.errMsgSure;
              this.showCommonModal = true;
            }
            this.getImage();
          }
          this.bigLoading = false;
        })
        .catch(() => {
          this.errMsgSure = this.$t("paygame.err2");
          this.bigLoading = false;
        });
    },
    goRePay() {
      if (this.payment_url) {
        window.open(this.payment_url);
      }
    },
    // v-model双向绑定触发input事件
    getInput(val) {
      this.params.captcha_code = val;

      this.emptyErrMsg2Key();
    },
    // 点击协议同意勾选框
    clickAgree() {
      this.agree = !this.agree;

      this.emptyErrMsg2Key();
    },
    // 弹窗按钮点击事件
    // 继续查询订单详情
    checkOrder() {
      if (!this.timeInterval) {
        this.checkBtn = false;
        // this.btnMsg = `${this.$t("paygame.requery")} 10 ${this.$t(
        //   "paygame.requeryUnit"
        // )}`;
        this.btnMsg = this.$t("paygame.requeryAfter", { requerySeconds: 10 });
        this.timeInterval = setInterval(() => {
          // 关闭查询按钮
          this.checkBtn = false;
          this.btnTime = this.btnTime - 1;
          // this.btnMsg = `${this.$t("paygame.requery")} ${
          //   this.btnTime
          // } ${this.$t("paygame.requeryUnit")}`;
          this.btnMsg = this.$t("paygame.requeryAfter", {
            requerySeconds: this.btnTime,
          });
          if (this.btnTime <= 0) {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
            this.btnMsg = this.$t("paygame.payTip9");
            this.btnTime = 10;
            this.checkBtn = true;
            // 获取订单详情
            this.getOrderDetail();
          }
        }, 1000);
      }
    },
    // loading页面 查询订单详情
    getOrderDetail() {
      if (this.order_no) {
        this.$apis.paygame
          .getOrderDetail(this.distribution_region, this.order_no)
          .then(({ data }) => {
            if (data.code == 0) {
              if (data.data.status == 1) {
                // 进入成功页面
                this.popShowPayLoading = false;
                this.popShowPaySearch = false;
                this.popShowMakeSure = true;
                // 展示订单详情
                this.type = 2;
                this.orderDetailInfo.game_id = data.data.game_id;
                this.orderDetailInfo.game_name = data.data.game_name;
                this.orderDetailInfo.account = data.data.nike_name;
                this.orderDetailInfo.cp_role_name = data.data.cp_role_name;
                this.orderDetailInfo.pay_mode = data.data.pay_mode;
                this.orderDetailInfo.payment_desc = data.data.pay_mode_name;
                this.orderDetailInfo.product_name = data.data.product_name;
                this.orderDetailInfo.product_icon = this.params.product_icon;
                this.orderDetailInfo.marketing_desc1 = this.params.marketing_desc1;
                this.orderDetailInfo.marketing_desc2 = this.params.marketing_desc2;
                this.orderDetailInfo.product_price = data.data.product_price;
                this.orderDetailInfo.currency = data.data.currency;
              } else {
                // 继续查询
                this.popShowPayLoading = false;
                this.popShowPaySearch = true;
              }
            } else if (data.code == -101) {
              this.$router.push({
                name: "login",
                query: { redirect: location.href },
              });
            } else {
              this.popShowPayLoading = false;
              this.popShowPaySearch = true;
            }
          });
      }
    },
    // 重新获取商品信息时清空选择
    emptyProductSelectInfo() {
      this.params.product_id = "";
      this.params.product_name = "";
      this.params.marketing_desc1 = "";
      this.params.marketing_desc2 = "";
      this.params.product_price = "";
      this.params.product_icon = "";
    },
    // 关闭提示弹窗
    closeModal() {
      this.errMsgInfo = "";
      this.popShowMakeSure = false;
      this.popShowPayLoading = false;
      this.popShowPaySearch = false;
      this.popCaptcha = false;
    },
    rePay() {
      this.closeModal();
      this.params.captcha_code = "";
      this.getImage();
      clearInterval(this.timeInterval);
    },
    // 关闭确认和支付成功弹窗
    closeOrderConfirm() {
      // 1: 确认订单 2:支付成功
      if (this.type == 1) {
        this.rePay();
        this.errMsgSure = "";
      } else {
        this.clearOrderData();
        this.closeModal();
      }
    },

    emptyErrMsg2Key() {
      // 选择区服
      if (
        this.params.game_id &&
        this.params.cp_server_id &&
        this.errMsg2Key === "msg1"
      ) {
        this.errMsg2Key = "";
      }
      if (this.params.serverStatus != 1 && this.errMsg2Key === "msg7") {
        this.errMsg2Key = "";
      }
      // 选择角色
      if (this.params.cp_role_id && this.errMsg2Key == "msg2") {
        this.errMsg2Key = "";
      }
      if (this.params.cp_role_pay_status != 1 && this.errMsg2Key == "msg8") {
        this.errMsg2Key = "";
      }
      // 选择商品
      if (this.params.product_id && this.errMsg2Key == "msg3") {
        this.errMsg2Key = "";
      }
      // 选择支付方式
      if (
        (this.params.payment_type || this.params.payment_type == "") &&
        this.errMsg2Key == "msg4"
      ) {
        this.errMsg2Key = "";
      }
      // 更换徒刑验证码
      if (this.params.captcha_code && this.errMsg2Key == "msg5") {
        this.errMsg2Key = "";
      }
      // 点击协议同意勾选框
      if (this.agree && this.errMsg2Key == "msg6") {
        this.errMsg2Key = "";
      }
    },
  },
  created() {
    // 1.获取平台充值开关状态
    this.getSwitchStatus();
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "./index.scss";
.__rail-is-horizontal {
  display: none;
}
.paygame-container {
  .el-radio-group {
    padding-right: 5px;
    .el-radio + .el-radio:nth-child(7n) {
      margin-left: 0;
    }
    .el-radio + .el-radio:nth-of-type(n + 7) {
      margin-top: 15px;
    }
  }
}
.product {
  .__view {
    padding-left: 15px !important;
    padding-top: 12px !important;
    // margin-left: -18px!important;
  }
}
</style>
